// extracted by mini-css-extract-plugin
export default {"root":"landingWelcome_root__bCOeg","left_bottom":"landingWelcome_left_bottom__HCGTm"};